import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { RoundedHint, TrianglePosition } from '@check24/hint';

/*
 * Styling
 */
const closeIconSize = 14;

export const StyledRoundedHint = styled(RoundedHint)<{ hide: boolean }>`
    ${({ hide }) =>
        hide &&
        css`
            display: none;
        `};
`;

const HintClose = styled.div`
    content: '';
    position: absolute;
    top: 10px;
    right: 10px;
    width: ${closeIconSize}px;
    height: ${closeIconSize}px;
    background-image: url('/img/close-grey.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
`;

const HelpTextContent = styled.div`
    font-size: 14px;
    padding-right: 16px;
    line-height: 1.3;
`;

/*
 * Component
 */
type HintProps = {
    hintType: string;
    infoTextProvider: string;
};

const getHintStyle = (type: string): { border: string; icon: string | undefined } => {
    switch (type) {
        case 'warning':
            return {
                border: '#e47600',
                icon: '/img/info-orange-icon.svg',
            };
        default:
            return {
                border: '#005ea8',
                icon: undefined,
            };
    }
};

const Hint: React.FC<HintProps> = (props) => {
    const { infoTextProvider, hintType } = props;

    const [hintIsHidden, setHintIsHidden] = useState<boolean>(false);

    const closeHint = () => {
        setHintIsHidden(!hintIsHidden);
    };

    const hintDef = getHintStyle(hintType);

    return (
        <StyledRoundedHint
            hide={hintIsHidden}
            trianglePosition={TrianglePosition.top}
            borderColor={hintDef.border}
            infoIcon={hintDef.icon}
        >
            <HelpTextContent dangerouslySetInnerHTML={{ __html: infoTextProvider }} />
            <HintClose onClick={closeHint} />
        </StyledRoundedHint>
    );
};

export default Hint;
